import ForecastLoanCalculator from "./ForecastLoanCalculator";

export default ForecastLoanCalculator;
